export const APIKEY="https://www.hrtech.sg/api"

// import axios from 'axios';

// export default axios.create({
//   baseURL: `http://jsonplaceholder.typicode.com/`
// });
